import { IDesk } from "../../../types/Floorplan.types";

export interface IDeskCanvasControlsProps {
    desks: IDesk[];
    selectedDeskIdx?: number;
}

const DeskCanvasControls = (props: IDeskCanvasControlsProps) => {
    const { desks, selectedDeskIdx } = props;
    if (selectedDeskIdx !== undefined) {
        const selectedDesk = desks[selectedDeskIdx];
        if (selectedDesk) {
            return (
                <svg id="deskControlHandles" x={desks[selectedDeskIdx].x+10} y={desks[selectedDeskIdx].y+12.5} overflow="visible">
                    <g transform={`rotate(${desks[selectedDeskIdx].rotation})`}>
                        <circle cx="0" cy="0" r="15" stroke="#b7b7b7" strokeDasharray="4" fill="none" />
                        <circle id="deskRotationHandle" cx="10" cy="-10" r="2" stroke="#999" strokeWidth="0.5" fill="white" />
                    </g>
                </svg>
            );
        }
    }
    return null;
};

export default DeskCanvasControls;